import echo from '../libs/echo';
import md5 from 'js-md5';


function lazyImg() {
  echo.init({
    offset: 100,//可是区域多少像素可以被加载
    throttle: 0 //设置图片延迟加载的时间
  });
}

//单点登录验证
function safeUser(_this) {
  _this.$store.dispatch("user/safeUser", {
    success: (res) => {
      if (res.code !== 200) {
        _this.$router.replace('/login');
      }
    }
  });
}

// 图片加载完成执行的事件
function loadImageEnd(list, callback, basePath) {
  if (!list || list.length === 0) return;
  if (basePath) list = list.map(item => basePath + item);
  let img = new Image();
  img.data = {
    list: list,
    callback: callback,
    resultList: [],
    num: 0
  }
  img.addEventListener("load", loadImgHandler);
  img.addEventListener("error", loadImgHandler);
  img.src = list[img.data.num];
}

function loadImgHandler(e) {
  let data = e.currentTarget.data;
  if (e.type !== 'error') {
    data.resultList.push(e.currentTarget.cloneNode(false));
  }
  data.num++;
  if (data.num > data.list.length - 1) {
    e.currentTarget.removeEventListener("load", loadImgHandler);
    if (data.callback) {
      data.callback(data.resultList);
    }
    data = null;
    return;
  }
  e.currentTarget.src = data.list[data.num];
}

export default {
  lazyImg,
  safeUser,
  loadImageEnd,
  md5
}